export default __webpack_public_path__ + "static/review-3-a3c70969e4544d0c393eedd12f562bc6.png";